let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Fhyh")).then(() => parcelRequire('kO0ZF'));